import styled from "styled-components";
import {Container} from "react-bootstrap";

export const GSPSError = styled(Container).attrs(() => ({
    className: "alert alert-danger",
}))``;
